module.exports = __webpack_public_path__ + "img/3.c2b246f1.png";